module.exports = __webpack_public_path__ + "static/img/AT.0447178b.svg";